import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './TableHeader.scss';

class TableHeader extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const { children, className } = this.props;
    const classComponent = classNames('table-header', className);

    return (
      <div role="rowgroup" className={classComponent}>
        {children}
      </div>
    );
  }
}

export default TableHeader;
